import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AxiosInstance from "../Home/AxiosInstance";
import "./traineePortal.css";

const TraineeSocialLink = () => {
  const [platform, setPlatform] = useState("");
  const [url, setUrl] = useState("");
  const { profileId } = useParams(); // if you need to reference profileId
  const navigate = useNavigate();

  const traineeId = localStorage.getItem("traineeId");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newSocialLink = {
      trainee: traineeId,
      platform,
      url,
    };

    try {
      const response = await AxiosInstance.post("companies/social_link", newSocialLink);
      if (response.status === 201 || response.status === 200) {
        console.log("Social link added:", response.data);
        navigate(-1);
      } else {
        console.error("Failed to create social link:", response);
      }
    } catch (error) {
      console.error("Error creating social link:", error);
    }
  };

  const closeModal = () => {
    navigate(-1);
  };

  return (
    <div className="als-trainee-form-page">
      <div className="als-trainee-form-card">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h2 className="mb-0">Add Social Link</h2>
            <button type="button" className="btn-close" aria-label="Close" onClick={closeModal}></button>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label htmlFor="platform" className="form-label">Platform</label>
              <input
                type="text"
                id="platform"
                className="form-control"
                value={platform}
                onChange={(e) => setPlatform(e.target.value)}
                placeholder="e.g. LinkedIn, GitHub"
                required
              />
            </div>

            <div className="mb-4">
              <label htmlFor="url" className="form-label">URL</label>
              <input
                type="url"
                id="url"
                className="form-control"
                value={url}
                onChange={(e) => setUrl(e.target.value)}
                placeholder="https://example.com/your-profile"
                required
              />
            </div>

            <div className="d-grid">
              <button type="submit" className="btn btn-primary">Save Link</button>
            </div>
          </form>
      </div>
    </div>
  );
};

export default TraineeSocialLink;
